import { render, staticRenderFns } from "./ShipmentPickUpPage.vue?vue&type=template&id=6dfa77d2&scoped=true"
import script from "./ShipmentPickUpPage.vue?vue&type=script&lang=js"
export * from "./ShipmentPickUpPage.vue?vue&type=script&lang=js"
import style0 from "./ShipmentPickUpPage.vue?vue&type=style&index=0&id=6dfa77d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfa77d2",
  null
  
)

export default component.exports